import React from 'react';
import { Box, TextField, styled } from '@mui/material';
import theme from '../themes/theme';
import CustomValidationText from './CustomValidationText';
import CustomLabel from './CustomLabel';


const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: '#FFFFFF',
    border: `1px solid #E4E7EC`,
    borderRadius: '10px',
    padding: '0px 0px 0px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    '&.Mui-focused': {
      backgroundColor: '#FFFFFF',
      borderColor: '#101828',
    },
    '& .MuiFilledInput-input': {
      padding: '15px 16px',
      height: 'auto',
      boxSizing: 'border-box',
    },
  },

  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.customColors.g100,
    opacity: 1,
  },
  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
      WebkitBoxShadow: '0 0 0 100px #FFFFFF inset',
      boxShadow: '0 0 0 100px #FFFFFF inset',
      WebkitTextFillColor: theme.palette.text.primary,
      caretColor: theme.palette.text.primary,
      borderRadius: '10px',
      transition: 'background-color 100000s ease-in-out 0s',
    },
}));



const CustomInputField = ({ label, placeholder, multiline = false ,minRows = 1 , type ='text', startAdornment, endAdornment, fullWidth = true,sx, value, labelStyle = {},hasError = false, errorMessage="", defaultValue, required = false, ...props  }) => {
  return (
    <Box sx={{width: `${fullWidth ? "100%" :  sx.width}`}}>
      {label != undefined && <CustomLabel required={required} sx={{ color: theme.palette.customColors.g500, marginBottom: '8px', display: 'block',fontSize:"0.875rem", ...labelStyle }}>
        {label}
      </CustomLabel>}
      <CustomTextField
        variant="filled"
        placeholder={placeholder}
        multiline={multiline}
        minRows={minRows}
        value={value}
        fullWidth
        sx={{...sx}}
        InputProps={{ disableUnderline: true , startAdornment: startAdornment, endAdornment: endAdornment}}
        type={type}
        defaultValue={defaultValue ? defaultValue : value}
        {...props}
      />
      {hasError && <CustomValidationText value={errorMessage} />}
    </Box>
  );
};
export default CustomInputField
